import PropsRoute from './PropsRoute';

export default PropsRoute;
